export default "__VITE_ASSET__x9T58ZH0__"